import QuickOrderModule from "@/modules/QuickOrder";

function QuickOrderPage() {
  return <QuickOrderModule />;
}

export default QuickOrderPage;
